module.exports = __webpack_public_path__ + "static/img/6.7a1311f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/zh/6.png
// module id = krzA
// module chunks = 0